// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"28e25121","252":"4c799a4b","314":"48fe2d27","546":"75cd708b","594":"7bd53892","596":"088c3269","606":"6048e658","823":"8d425b9a"}[chunkId] + ".chunk.js";
};